import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: null,
  displayText: '',
  loading: false,
};

const timezoneSlice = createSlice({
  name: 'workkardForm/timezone',
  initialState,
  reducers: {
    setTimezoneRequest(state, action) {
      state.loading = true;
    },
    setTimezoneSuccess(state, action) {
      state.id = action.payload.id;
      state.displayText = action.payload.displayText;
      state.loading = false;
    },
    setTimezoneFailure(state) {
      state.loading = false;
    },
    clearTimezone(state) {
      state.id = null;
      state.displayText = '';
      state.loading = false;
    },
    setTimezoneFromId(state, action) {
      const id = action.payload?.timeZoneId || null;
      state.id = id;
      state.displayText = timeZoneIdToDisplayText(id);
      state.loading = false;
    },
  },
});

function timeZoneIdToDisplayText(id) {
  if (!id) return '';
  const MAP = {
    'America/New_York': 'Eastern Time (ET)',
    'America/Chicago': 'Central Time (CT)',
    'America/Denver': 'Mountain Time (MT)',
    'America/Phoenix': 'Mountain Time (MT)',
    'America/Los_Angeles': 'Pacific Time (PT)',
    'America/Anchorage': 'Alaska Time (AKT)',
    'Pacific/Honolulu': 'Hawaii Time (HT)',
    'Asia/Kolkata': 'India Time (IST)',
    'Europe/London': 'UK Time (GMT/BST)',
    'Europe/Athens': 'Greece Time (EET)',
    'Africa/Nairobi': 'Kenya Time (EAT)',
    'America/Toronto': 'Eastern Time (ET)',
  };
  return MAP[id] || id;
}

export const {
  setTimezoneRequest,
  setTimezoneSuccess,
  setTimezoneFailure,
  clearTimezone,
  setTimezoneFromId,
} = timezoneSlice.actions;

export default timezoneSlice.reducer;
